import React from "react";
import { Image, Box, Text, Grid, Flex } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";
// import { FaGithub } from "react-icons/fa";
import "./Skills/Skills.css"

export default function Statistics() {
  return (
    <Box
      id="statistics"
      className="statistics section"
      pt={["", "", ""]}
      my={"30px"}
      bg={"#040724"}
      // border={"1px solid white"}
    >
      <Box w="85%" border={"0px solid white"} m="auto">
        <Box
          display={"flex"}
          color="#00b9e8"
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"row"}
          textAlign="center"
          fontWeight="400"
          fontSize={["2xl", "4xl", "5xl"]}
        >
          <Text>Github Statistics</Text>
          {/* <Text fontSize={["2xl", "4xl", "5xl"]}>
            <FaGithub className="bounce" />
          </Text> */}
        </Box>
        <Grid
          pt={["20px", "25px", "30px"]}
          templateColumns={"repeat(1,1fr)"}
          margin={"auto"}
          gap={3}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
          border={"0px solid pink"}
        >
          <Box border={"0px solid lightgreen"}>
            <Flex
              flexDirection={["column", "column", "column", "row", "row"]}
              justifyContent={"space-around"}
              alignItems={"center"}
              m={"auto"}
              gap={[5, 6, 7, 8, 9]}
            >
              <Image
                alt="github-stats-card"
                id="github-stats-card"
                w={"100%"}
                src="https://github-readme-stats.vercel.app/api?username=AyushiVashisth&bg_color=00000000&theme=great-gatsby&show_icons=true&icon_color=ffa500&border_color=ffa500&text_color=00b9e8"
              />

              <Image
                alt="github-streak-stats"
                id="github-streak-stats"
                w={"100%"}
                src="https://github-readme-streak-stats.herokuapp.com?user=AyushiVashisth&background=00000000&theme=great-gatsby&border=ffa500&fire=F1E05A&currStreakNum=FFFFFF&currStreakLabel=ffa500&dates=00b9e8"
              />
            </Flex>
          </Box>
          <Box border={"0px solid yellow"}>
            <Image
              alt="github-top-langs"
              id="github-top-langs"
              width={["100%", "100%", "100%", "100%", "100%"]}
              m={"auto"}
              src={
                "https://github-readme-stats.vercel.app/api/top-langs/?username=AyushiVashisth&bg_color=00000000&layout=compact&theme=great-gatsby&border_color=ffa500&text_color=ffa500&card_width=600"
              }
            />
          </Box>
        </Grid>

        <Box
          border={"2px solid #ffa500"}
          borderRadius={"10px"}
          bg="none"
          color="#ffa500"
          padding={[6, 8, 10]}
          margin={"auto"}
          mt={["10px", "10px", "20px"]}
          className="gitcal"
          // w={'80%'}
        >
          <GitHubCalendar
            username="AyushiVashisth"
            color={"#00b9e8"}
            textAlign={"center"}
            justifyContent={"center"}
            blockMargin={6}
            blockSize={20}
            hideColorLegend={true}
          />
        </Box>
      </Box>
    </Box>
  );
}